import React from 'react';
import {
  Box,
  Typography,
  Grid,
  Card,
  CardActionArea,
  ListItemIcon,
} from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import SettingsIcon from '@mui/icons-material/Settings';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import PersonIcon from '@mui/icons-material/Person';
import PeopleIcon from '@mui/icons-material/People';
import CategoryIcon from '@mui/icons-material/Category';
import PercentIcon from '@mui/icons-material/Percent';
import TuneIcon from '@mui/icons-material/Tune';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ListAltIcon from '@mui/icons-material/ListAlt';

const parameters = [
  {
    title: 'Bank Management',
    description: 'Manage bank master data.',
    icon: <AccountBalanceIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/bank-management',
  },
  {
    title: 'Bank Account Management',
    description: 'Configure bank accounts.',
    icon: <AccountBalanceWalletIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/bank-account-management',
  },
  {
    title: 'Borrower Management',
    description: 'Manage borrower profiles.',
    icon: <PeopleIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/borrower-management',
  },
  {
    title: 'Borrower Bank Account',
    description: 'Link bank accounts to borrowers.',
    icon: <PersonIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/borrower-bank-account',
  },
  {
    title: 'Interest Rate Maintenance',
    description: 'Maintain interest rate details.',
    icon: <PercentIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/interest-rate-maintenance',
  },
  {
    title: 'Loan Type Maintenance',
    description: 'Define different types of loans.',
    icon: <ListAltIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
    path: '/parameters/loan-type',
  },
  // Add other parameter items if needed, e.g.:
  // {
  //   title: 'Currency Master',
  //   description: 'Manage currencies and exchange rates.',
  //   icon: <AttachMoneyIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
  //   path: '/parameters/currency',
  // },
  // {
  //   title: 'Loan Parameters',
  //   description: 'Configure general loan parameters.',
  //   icon: <TuneIcon sx={{ fontSize: 32, color: '#6366F1' }} />,
  //   path: '/parameters/loan',
  // },
];

const ParameterSelection: React.FC = () => {
  return (
    <Box sx={{ p: 3, bgcolor: '#F9FAFB', flexGrow: 1 }}>
      <Typography variant="h4" gutterBottom sx={{ mb: 3, color: '#111827', fontWeight: 'bold' }}>
        Parameters
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Configure master data and application settings.
      </Typography>
      <Grid container spacing={3}>
        {parameters.map((param, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card
              sx={{
                height: '100%',
                borderRadius: 2,
                transition: 'box-shadow 0.3s ease-in-out',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06)',
                '&:hover': {
                  boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                },
                bgcolor: '#FFFFFF'
              }}
            >
              <CardActionArea
                component={RouterLink}
                to={param.path}
                sx={{
                  p: 2,
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                }}
              >
                <Box sx={{ display: 'flex', alignItems: 'center', flexGrow: 1 }}>
                  <ListItemIcon sx={{ mr: 2, minWidth: 'auto' }}>
                    {param.icon}
                  </ListItemIcon>
                  <Box>
                    <Typography variant="h6" component="div" sx={{ fontWeight: 600, color: '#111827', fontSize: '1rem' }}>
                      {param.title}
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#6B7280', fontSize: '0.875rem' }}>
                      {param.description}
                    </Typography>
                  </Box>
                </Box>
                <ChevronRightIcon sx={{ color: '#9CA3AF' }} />
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default ParameterSelection; 